;(function(global, $){
    'use strict';

    function createTabStrip() {
        var tabStrip = $('#learning-center-tabstrip');
        var tabs = tabStrip.find('.tab');
        var tabsCount = tabs.length;

        tabs.on('click', function(ev) {
            var nextTab = $(this);
            var currentTab = tabStrip.find('.active');
            var currentIndex = currentTab.data().index;
            var nextIndex = nextTab.data().index;

            if (currentIndex !== nextIndex) {
                currentTab.removeClass('active');
                tabStrip.find('#tab-content-' + currentIndex).hide();

                nextTab.addClass('active');
                tabStrip.find('#tab-content-' + nextIndex).show();
            }
        });
    }

    $(function() {
        createTabStrip();
    });

}(window, jQuery));

